/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateTicketRequest,
    CreateTicketResponse,
    ZendeskUserInfo,
} from '../models';

export interface ZendeskApiControllerCreateTicketRequest {
    createTicketRequest: CreateTicketRequest;
}

/**
 * 
 */
export class ZendeskApi extends runtime.BaseAPI {

    /**
     */
    async zendeskApiControllerCreateTicketRaw(requestParameters: ZendeskApiControllerCreateTicketRequest): Promise<runtime.ApiResponse<CreateTicketResponse>> {
        if (requestParameters.createTicketRequest === null || requestParameters.createTicketRequest === undefined) {
            throw new runtime.RequiredError('createTicketRequest','Required parameter requestParameters.createTicketRequest was null or undefined when calling zendeskApiControllerCreateTicket.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/zendesk/tickets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTicketRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async zendeskApiControllerCreateTicket(requestParameters: ZendeskApiControllerCreateTicketRequest): Promise<CreateTicketResponse> {
        const response = await this.zendeskApiControllerCreateTicketRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async zendeskApiControllerGetUserInfoRaw(): Promise<runtime.ApiResponse<ZendeskUserInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/zendesk/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async zendeskApiControllerGetUserInfo(): Promise<ZendeskUserInfo> {
        const response = await this.zendeskApiControllerGetUserInfoRaw();
        return await response.value();
    }

}
